import './App.css';
import { useState, useEffect } from 'react';
import CatalogPage from './components/CatalogPage';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container } from 'semantic-ui-react'
import CharacterPage from './components/CharacterPage';

function App() {
  const [people, setPeople] = useState([]);

  useEffect(() => {
    let mounted = true;
    

    async function fetchPeople() {
      try {
        const response = await fetch('https://swapi.py4e.com/api/people/?format=json');
        const data = await response.json();
        if (mounted) setPeople(data.results || []);
      } catch (err) {
        console.error('Failed to fetch people:', err);
        if (mounted) setPeople([]);
      }
    }
    fetchPeople();
    return () => { mounted = false; };
  },[])
  return (
    <Router>
      <Container>
        <Switch>
          <Route exact path='/'>
            <CatalogPage data={people} />
          </Route>
          <Route exact path='/character/:id'>
            <CharacterPage/>
          </Route>
        </Switch>
      </Container>
    </Router>
  )
}

export default App;
